export default class Utils {

  static hijackAllLogs() {
    console.log=function(){return;}
    console.error=function(){return;}
    console.warn=function(){return;}
  }

  static hijackReduxDevTools() {
    if(window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__.disconnect) {
      window.__REDUX_DEVTOOLS_EXTENSION__.disconnect();
      window.__REDUX_DEVTOOLS_EXTENSION__.connect = function(){return;}
    }
  }

  static encodeUtf8(s) {
    return unescape(encodeURIComponent(s));
  }

  static decodeUtf8(s) {
    return decodeURIComponent(escape(s));
  }

  static SessionStorage = {
      set: (key, value) => {
        if(window.sessionStorage) {
          let _val = null;
          if(typeof value === "object")
            _val = JSON.stringify(value);
          else if(typeof value === "string")
            _val = value;
          else console.error(`Type of value is not allowed ${value} typeof: ${typeof value}`)
          window.sessionStorage.setItem(key, _val);
        }
      },
      get: (key) => {
        return window.sessionStorage.getItem(key);
      }
  }
  /**
   *
   * @param {Array} a - first array.
   * @param {Array} b - second array.
   * @description compares a values to b
   */
  static compareArrays(a, b) {
    let similar = true;

    for (let val in a) {
      if (!b.includes(a[val])) {
        similar = false;
      }
    }

    return similar;
  }
  
  /**
   * 
   * @param {React.KeyboardEvent<HTMLInputElement>} evt 
   */
  static isNumberKey(evt){
    if(isNaN(Number(evt.key))) evt.preventDefault()
  }

  /**
   * 
   * @param {String} symbol 
   * @param {String} str 
   */
  static sliceAfter(symbol, str) {
    return str.slice(str.lastIndexOf(symbol) + 1, str.length)
  }

  /**
   * 
   * @param {String} symbol 
   * @param {String} str 
   */
  static sliceBetween(symbol, str) {
    if(symbol.length !== 2) {
      return str;
    }

    let subsym = symbol.split('');
    return str.substring(str.indexOf(subsym[0]) + 1, str.indexOf(subsym[1]));
  }

  /**
   *
   * @param {String} groupParam A key to group the elements with its value
   * @description Groups an array of objects with specific key value
   * @returns Object of arrays
   */
  static groupBy(array, groupParam) {
    let groupedObject = {};

    array.forEach(el => {
      if (!groupedObject[el[groupParam]]) groupedObject[el[groupParam]] = [];

      groupedObject[el[groupParam]].push(el);
    });

    return groupedObject;
  }

  static isValidPhone(number) {
    const re = /^0\d{2}\d{8}$/;

    if (!number) return false;

    let result = number.match(re);

    if (result) {
      return result[0] && result[0].length === number.length;
    }

    return false;
  }

  static isValidEmail(email) {
    const re = /([\w\d._-])*[@]([\w]*[.][\w]*)*$\b/;

    if (!email) return false;

    let matches = email.match(re);

    if (matches) {
      if (email.length === matches[0].length) return true;
      else return false;
    }

    return false;
  }

  static scrollToElement(element) {
    if (!element) return;
    let scrollElement = null;

    if(document.scrollingElement) {
      scrollElement = document.scrollingElement;
    } else {
      scrollElement = document.querySelector('html');
    }

    const rect = element.getBoundingClientRect();
    const scrollOpts = { top: scrollElement.scrollTop + rect.top - 100, behavior: "smooth" }
    window.scroll(scrollOpts);
  }

  static isPointInRect(px, py, rx, ry, rw, rh) {
    return rx <= px && px <= rx + rw &&
               ry <= py && py <= ry + rh;
  }
}
